import { useAppTranslation } from "@/hooks/use-app-translation";
import {
	type DynamicFormEntityKind,
	type DynamicFormRequirementMode,
	hasRequiredDynamicFormField,
	requirementNoticeKey,
} from "../utils/requirement-mode.util";

export function DynamicFormRequirementNotice({
	mode,
	entityKind,
	fieldDefinitions,
}: {
	mode: DynamicFormRequirementMode;
	entityKind?: DynamicFormEntityKind;
	fieldDefinitions?: readonly { required?: boolean | null }[] | null;
}) {
	const { t } = useAppTranslation();
	const key = requirementNoticeKey(mode, entityKind);
	if (!key || !hasRequiredDynamicFormField(fieldDefinitions)) return null;
	return <p className="text-sm text-secondary">{t(key)}</p>;
}
